export default {
    listagem: {
        titulo_pagina: 'Lista de Tiempos',
        novo: 'Crear Nuevo Tiempo',
        habilitado: 'Capaz',
        desabilitado: 'Desactivado',
        table: {
            empty: 'No se encontró el tiempo',
            nome: 'Nombre',
            codigo: 'Código',
            editar: 'Editar'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Crear Nuevo Tiempo',
            editar: 'Editar Tiempo'
        },
        fields: {
            codigo: {
                label: 'Código',
                description: 'Código del Tiempo'
            },
            nome: {
                label: 'Nombre',
                description: 'Nombre del Tiempo'
            },
            status: {
                label: 'Estado',
                description: 'Estado activo o inactivo del tiempo'
            },
            botao_salvar : 'Guardar Tiempo'
        },
        create: {
            success: '¡Tiempo creado con éxito!',
            error: '¡Error al crear el tiempo!'
        },
        update: {
            success: '¡Tiempo editado con éxito!',
            error: '¡Error al editar el tempo!'
        }
    }
}
